<!-- eslint-disable -->
<template lang="pug">
    div.answer-container
        drop.answer-container__drop(
            @drop="drop('example')"
            :style='firstAnswerContainerDropStyle'
        )
            .link(
                v-for="(item, index) in example",
                :key='index'
            )
                drag.answers-container__drag(
                    :draggable="!item.disabled"
                    :transfer-data="{ item, index, from: 'example'}"
                    @dragstart="dragstart"
                )
                    div(class="answer")
                        | {{ item.value }}
        .answer-containers
            .answer-container__title
                | {{ $i18n.t(`trainer.trainer_gameFormSetting_verbs`) }}
            .answer-container__title
                | {{ $i18n.t(`trainer.trainer_gameFormSetting_nouns`) }}
            .answer-container__title
                | {{ $i18n.t(`trainer.trainer_gameFormSetting_adjectives`) }}
            drop.answer-container__drop(
                @drop="drop('leftColumnData')"
            )
                .link(
                    v-for="(item, index) in leftColumnData",
                    :key='index'
                )
                    drag.answers-container__drag(
                        :draggable="!item.disabled"
                        :transfer-data="{ item, index, from: 'leftColumnData'}"
                        @dragstart="dragstart"
                    )
                        div(
                            class="answer"
                            :class="{ 'answer_correct': item.disabled }",
                        )
                            | {{ item.value }}
            drop.answer-container__drop(
                @drop="drop('rightColumnData')"
            )
                .link(
                    v-for="(item, index) in rightColumnData",
                    :key='index'
                )
                    drag.answers-container__drag(
                        :draggable="!item.disabled"
                        :transfer-data="{ item, index, from: 'rightColumnData'}"
                        @dragstart="dragstart"
                    )
                        div(
                            class="answer"
                            :class="{ 'answer_correct': item.disabled }",
                        )
                            | {{ item.value }}
            drop.answer-container__drop(
                @drop="drop('centralColumnData')"
            )
                .link(
                    v-for="(item, index) in centralColumnData",
                    :key='index'
                )
                    drag.answers-container__drag(
                        :draggable="!item.disabled"
                        :transfer-data="{ item, index, from: 'centralColumnData'}"
                        @dragstart="dragstart"
                    )
                        div(
                            class="answer"
                            :class="{ 'answer_correct': item.disabled }",
                        )
                            | {{ item.value }}
</template>

<script>
    /*eslint-disable*/
    import { Drag, Drop } from 'vue-drag-drop';

    export default {
        components: {
            Drag,
            Drop,
        },
        emits: ['update:example', 'update:leftColumnData', 'update:rightColumnData', 'update:centralColumnData'],
        props: {
            parameters: {
                type: Object,
                default: () => ({}),
            },
            example: {
                type: Array,
                default: () => [],
            },
            leftColumnData: {
                type: Array,
                default: () => [],
            },
            rightColumnData: {
                type: Array,
                default: () => [],
            },
            centralColumnData: {
                type: Array,
                default: () => [],
            }
        },
        computed: {
            firstAnswerContainerDropStyle() {
                const width =
                    window.screen.width >= 1200
                        ? this.parameters.amountOfPairs * 2 * 67 - 10
                        : this.parameters.amountOfPairs * 2 * 75 - 190;
                return {
                    width: `min(${width}px, calc(100% - 60px))`,
                };
            },
        },
        data() {
            return {
                dragElement: null,
                dragIndex: null,
                dragForm: null,
            };
        },
        methods: {
            drop(form) {
                if (this.dragForm === form) {
                    this.dragElement = null;
                    this.dragIndex = null;
                    this.dragForm = null;
                    return;
                }
                const oldValue = [...this[this.dragForm]];
                oldValue.splice(this.dragIndex, 1);
                this.$emit(`update:${this.dragForm}`, oldValue);
                const newValue = [...this[form]];
                newValue.unshift(this.dragElement);
                this.$emit(`update:${form}`, newValue);
            },
            dragstart({ item, index, from }) {
                this.dragElement = item;
                this.dragIndex = index;
                this.dragForm = from;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .answer-container {
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .answer-container__drop {
        background: white;
        padding: 20px;
        margin: 10px;
        display: flex;
        gap: 15px;
        min-height: 50px;
        min-width: 100px;
        border-radius: 30px;
        overflow: auto;
    }

    .answer-containers {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        .answer-container__title {
            font-size: 24px;
            font-weight: 600;
            text-align: center;
            align-self: center;
            max-width: 300px;
            @media screen and (max-width: 900px) {
                font-size: 20px;
            }
            @media screen and (max-width: 600px) {
                font-size: 16px;
            }
            @media screen and (max-width: 300px) {
                font-size: 14px;
            }
        }
        .answer-container__drop {
            flex-direction: column;
            align-items: center;
            @include media($xlg) {
                max-width: 360px;
            }
        }
    }

    .answers-container__drag {
        position: relative;
        font-size: 24px;
        @include media($xlg) {
            font-size: 28px;
        }
    }

    .answer {
        border: 1px solid $color-grey-600;
        cursor: grab;
        //position: absolute;
        left: 0;
        top: 0;
        height: 40px;
        text-align: center;
        background: lightgray;
        color: black;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        padding: 0px 10px;
        &.answer_correct {
            cursor: not-allowed;
            opacity: 0.4;
        }
        @include media($xlg) {
            border-radius: 25px;
            height: 50px;
        }
    }

    .link {
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
